import TicketSearchController from './ticket.search.controller';

export default {
    template: require('./ticket.search.html'),
    controller: TicketSearchController
};
